// extracted by mini-css-extract-plugin
export default {"carousel":"EiVbV","carouselItem":"v506u","singleLook":"bN5CC","multipleLooks":"T647W","heroImage":"OK8kX","thumbnailContainer":"pm6IX","thumbnail":"_UVd5","lightTheme":"cpNTZ"};